/**
 * 種別
 */
 export type SkillType =
 | "1" // 言語
 | "2" // 技術
 | "3"; // その他

export const Language = "1" as SkillType;
export const Tool = "2" as SkillType;
export const Others = "3" as SkillType;

/**
 * 受注必須スキル
 */
export interface Skill {
  skillName: string;
  level: number;
}

/**
 * スキルマスタ
 */
export interface SkillMastar {
  skillId: number;
  type: SkillType;
  skillName: string;
  extension: string | null;
  languageColor: string;
}